module.exports = __webpack_public_path__ + "img/5.a11c63fc.jpeg";